import styled from 'styled-components';

export const StyledArrow = styled.svg<{ arrowLeft?: boolean }>`
  transform: ${({ arrowLeft }) => arrowLeft && 'rotate(180deg)'};
`;
